module.exports = __webpack_public_path__ + "static/media/progress_update.0bc1a121.svg";